import * as SplashScreen from "expo-splash-screen";
import { nl, registerDefaultLocale, registerTranslation } from "react-native-use-form";

registerTranslation("nl", nl);
registerDefaultLocale("nl");

SplashScreen.hideAsync();
export default function GestureRootViewAndFont({ children }: { children: any }) {
  return children;
}
